/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommonResponseDto
 */
export interface CommonResponseDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof CommonResponseDto
     */
    workflowInstanceId?: string;
}

/**
 * Check if a given object implements the CommonResponseDto interface.
 */
export function instanceOfCommonResponseDto(value: object): boolean {
    return true;
}

export function CommonResponseDtoFromJSON(json: any): CommonResponseDto {
    return CommonResponseDtoFromJSONTyped(json, false);
}

export function CommonResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommonResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
    };
}

export function CommonResponseDtoToJSON(value?: CommonResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
    };
}

